




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { AdContentBlockViewModel, ProductDetailsViewModel } from '@/types/apiServerContract';
import { AdnuntiusTrackingData } from '@/project/tracking/adnuntius/types';
import Api from '@/project/http/Api.service';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';
import ImageTextVideoBlock from '@/project/app/blocks/ImageTextVideoBlock.vue';

@Component({
    components: { ImageTextVideoBlock, AdnuntiusPixels }
})
export default class AdnuntiusProductDetailsBannerBlock extends Vue {
    @Prop() product!: ProductDetailsViewModel;
    adContentBlockViewModel: AdContentBlockViewModel | null = null;
    adnuntiusTrackingData: AdnuntiusTrackingData | null = null;
    contentLoadError = false;
    loaded = false;

    created() {
        this.init();
    }

    async init() {
        await Promise.all([this.getAdContent()]).finally(() => this.loaded = true);
    }

    async getAdContent() {
        try {
            this.adContentBlockViewModel = await Api.personalization.productDetailBanner({
                contactKey: adnuntiusService.getContactKey(),
                customerKey: adnuntiusService.getCustomerKey(),
                currentUrl: this.$route.fullPath,
                brand: this.product.brand || '',
                categoryIds: this.product.categoryId ? [this.product.categoryId] : [],
                itemId: this.product.itemId
            });

            if (this.adContentBlockViewModel.lineItemId && this.adContentBlockViewModel.creativeId) {
                this.adnuntiusTrackingData = {
                    lineItemId: this.adContentBlockViewModel.lineItemId,
                    creativeId: this.adContentBlockViewModel.creativeId,
                    parentBlockAlias: 'productDetailsBannerBlock'
                };
            }
        } catch {
            this.contentLoadError = true;
        }
    }

    get renderedPixelUrl() {
        return this.adContentBlockViewModel?.renderedPixelUrl;
    }

    get viewPixelUrl() {
        return this.adContentBlockViewModel?.viewPixelUrl;
    }

    get visiblePixelUrl() {
        return this.adContentBlockViewModel?.visiblePixelUrl;
    }

    get clickPixelUrl() {
        return this.adContentBlockViewModel?.clickPixelUrl;
    }
}
